export default "__VITE_ASSET__2LXuTJFL__"